<template>

  <div>
    <div class="app-main__inner">
      <TituloComponent icono-titulo="fas fa-pencil-alt" texto-titulo="Editar Cargo"></TituloComponent>
      <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
        
        <div class="card-body">
          <form @submit.prevent="guardarCargo()">
            <float-label label="Código:" clase>
              <input
                v-model="cargo.codigo"
                id="codigo"
                placeholder="Ingresar un código..."
                type="text"
                class="form-control"
                :class="(enviado && !$v.cargo.codigo.required) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.cargo.codigo.required"
                >Debe ingresar una código</div>
              </template>
            </float-label>
            <float-label label="Descripción:" clase>
              <input
                v-model="cargo.descripcion"
                id="descripcion"
                placeholder="Ingresar una descripción..."
                type="text"
                class="form-control"
                :class="(enviado && !$v.cargo.descripcion.required) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.cargo.descripcion.required"
                >Debe ingresar una descripción</div>
              </template>
            </float-label>            
            <float-label label="Código nomenclador:" clase>
              <input
                v-model="cargo.codigo_nomenclador"
                id="codigo_nomenclador"
                placeholder="Ingresar código de nomenclador..."
                type="text"
                class="form-control"
                :class="(enviado && !$v.cargo.codigo_nomenclador.required) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.cargo.codigo_nomenclador.required"
                >Debe ingresar un código de nomenclador</div>
              </template>
            </float-label>
            <float-label label="Cantidad de horas:" clase>
              <input
                v-model="cargo.cantidad_horas"
                id="cantidad_horas"
                placeholder="Ingresar cantidad de horas..."
                type="text"
                class="form-control"
                :class="(enviado && !$v.cargo.cantidad_horas.required) ? 'is-invalid' : ''"
              />
              <template v-slot:validation>
                <div
                  class="invalid-feedback"
                  v-if="enviado && !$v.cargo.cantidad_horas.required"
                >Debe ingresar cantidad de horas</div>
              </template>
            </float-label>
            <button class="mt-1 btn btn-info float-right">Guardar</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponente";
import FloatLabel from "@/components/layouts/FloatLabel";
import { required } from 'vuelidate/lib/validators';
import axios from "axios";
import Swal from "sweetalert2";
import Cargo from "@/models/cargo";
export default {
  name: "EditarCargo",
  components: {
    TituloComponent,
    FloatLabel
  },
  data() {
    return {
      cargo: new Cargo(null,"", "", null, null),
      loading: false,
      enviado:false,
    };
  },  
  validations:{
    cargo:{
      codigo:{required},
      descripcion:{required},
      codigo_nomenclador: { required },
      cantidad_horas: { required },
    }
  },
  mounted() {
    this.cargo.id = this.$route.params.id;
    this.getCargo();
  },
  methods: {
    getCargo() {
      this.loading = true;
      axios
        .get("cargos/" + this.cargo.id)
        .then(res => {
          if (res.data.success) {
            this.cargo = res.data.cargo;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "Oopss..",
            text: `No se ha encontrado cargo.`
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardarCargo() {
      this.enviado = true
      this.loading = true;
      this.$v.$touch();
      if(this.$v.$invalid){
        this.loading = false;
        return false;
      }
      axios
        .put("/cargos/"+this.cargo.id, this.cargo)
        .then(res => {
          if (res.data.success) {
            Swal.fire({
              icon: "success",
              title: "Éxito",
              text: `${res.data.cargo.descripcion} se editó con éxito.`
            });
            this.$router.push({ name: "ListarCargos" });
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Oopss..",
            text: `No se ha podido completar la operación.`
          });
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>